import { CLOUDINARY_CLOUD_NAME } from './cloudinary';

const CLOUDINARY_IMAGE_BASE = `https://res.cloudinary.com/${CLOUDINARY_CLOUD_NAME}/image/upload`;

/** Cloudinary public id for chatbot icon (PNG — asset is raster, not SVG). */
const SITE_ICON_VERSION_PATH = 'v1779300898/chatbotlogo1_bczgog.png';

/** Site / chatbot icon — PNG on Cloudinary (do not bundle locally). */
export const SITE_ICON_SVG_URL = `${CLOUDINARY_IMAGE_BASE}/${SITE_ICON_VERSION_PATH}`;

/** Browser tab icon (SVG). Google Search icons: search-favicon-*.png + /favicon.ico in public/. */
export const SITE_ICON_SVG_URL_LOCAL = '/favicon.svg';
export const SEARCH_FAVICON_URL = '/favicon.ico';
export const SEARCH_FAVICON_PNG_48_URL = '/search-favicon-48x48.png';
export const SEARCH_FAVICON_PNG_96_URL = '/search-favicon-96x96.png';
export const SEARCH_FAVICON_PNG_192_URL = '/search-favicon-192x192.png';
export const SEARCH_FAVICON_PNG_512_URL = '/search-favicon-512x512.png';
export const SITE_ICON_PNG_48_URL = '/favicon-48x48.png';
export const SITE_ICON_PNG_96_URL = '/favicon-48x48.png';
export const SITE_ICON_PNG_192_URL = '/favicon-192x192.png';
export const SITE_ICON_PNG_512_URL = '/logo512.png';

/** Header wordmark — SVG on Cloudinary (do not bundle locally). */
export const HEADER_LOGO_URL = `${CLOUDINARY_IMAGE_BASE}/v1779301379/Databiqs_Logo_xeqpdr.svg`;

/** Footer wordmark — SVG on Cloudinary (do not bundle locally). */
export const FOOTER_LOGO_URL = `${CLOUDINARY_IMAGE_BASE}/v1779300705/footer-logo_gz7rmq.svg`;

/** Footer social icons — SVG on Cloudinary. */
export const FOOTER_LINKEDIN_ICON_URL = `${CLOUDINARY_IMAGE_BASE}/v1779301555/linkedin_mwhnj5.svg`;

export const FOOTER_INSTAGRAM_ICON_URL = `${CLOUDINARY_IMAGE_BASE}/v1779301501/insta_czy6mf.svg`;
